import { Form } from 'antd';

import { useBranches, useCreateProduct } from '../../hooks';
import { removeObjectProperties } from '../../utils';
import { Card, FormActions, FormSkeleton, PageHeader } from '../../components';
import { ROUTE_URLS } from '../../routes';
import { useI18n } from '../../i18n';
import { ProductFields } from './ProductFields';

export const CreateProduct = () => {
  const { t } = useI18n();
  const { data: branches, isLoading: isLoadingBranches } = useBranches();
  const { isLoading, mutateAsync: createProduct } = useCreateProduct();

  const createSellPricesArray = values => {
    const branchSellPrices = {};
    branches.forEach(branch => {
      branchSellPrices[branch.id] = values[branch.id];
    });
    return branchSellPrices;
  };

  const onFinish = values => {
    const readyValues = {
      status: 1,
      branch_ids: createSellPricesArray(values),
      ...removeObjectProperties(values, [
        'branchSearchValue',
        ...branches.map(branch => branch.id),
      ]),
    };

    createProduct(readyValues);
  };

  return (
    <div className='wm-form-page'>
      <PageHeader
        backTo={ROUTE_URLS.PRODUCTS}
        backLabel={t('nav.products')}
        title={t('products.createTitle')}
        subtitle={t('products.createSubtitle')}
      />
      {isLoadingBranches ? (
        <Card>
          <FormSkeleton fields={5} />
        </Card>
      ) : (
        <Form
          name='createProducts'
          layout='vertical'
          onFinish={onFinish}
          requiredMark={false}
          initialValues={{
            quantity: 0,
          }}
        >
          <ProductFields branches={Array.isArray(branches) ? branches : []} />
          <FormActions cancelTo={ROUTE_URLS.PRODUCTS} submitting={isLoading} />
        </Form>
      )}
    </div>
  );
};
